import { getItem, setItem, removeItem } from 'libs/store'

// TODO-TS-MIGRATION-MEDIUM: Phase 4에서 RootState 타입 적용 필요
// Redux store가 TypeScript로 변환된 후 menu, settings state 타입 정의 필요
type EnvParamRecord = Record<string, any>

const envParam: EnvParamRecord = {}

// Lazy store initialization - 테스트 환경에서 index.ts 전체 부트스트랩 방지
let _store: any = null

export function _initStore(store: any): void {
  _store = store
}

function getStore(): any {
  if (!_store) {
    throw new Error('Store not initialized. Call _initStore(store) from index.ts first.')
  }
  return _store
}

/**
 * dev hook/E2E에서 현재 Redux store에 접근할 때 사용한다.
 * 일반 앱 로직은 기존처럼 내부 getStore()만 사용하고, 외부 노출은 최소화한다.
 */
export function getReduxStore(): any {
  return getStore()
}

export function getRouterType(): 'hash' | 'browser' {
  return 'browser' // hash, browser
}

export function getDefaultPage(): string {
  const state = getStore().getState() as any // TODO-TS-MIGRATION-MEDIUM: Phase 4에서 RootState 타입 적용
  const { menu } = state
  if (menu != null) {
    const { configData } = menu
    return configData.defaultPage
  }
  return '/'
}

export function setEnvParam(key: string, value: any): void {
  envParam[key] = value
  setItem(`envParem.${key}`, value)

  if (key === 'appType') {
    getStore().dispatch({
      type: 'menu/RELOAD',
    })
  }
}

export function getEnvParam(key: string): any {
  // UI 테스트용..~!!!!
  // if (key === 'appType') {
  //   return 'REWORK-ENTERPRISE-PORTAL'
  // }

  if (envParam[key] == null) {
    return getItem(`envParem.${key}`)
  }
  return envParam[key]
}

export function removeEnvParam(key: string): void {
  removeItem(`envParem.${key}`)
  delete envParam[key]
}

const tempEnvParam: EnvParamRecord = {}

export function setTempEnvParam(key: string, value: any): void {
  tempEnvParam[key] = value
}

export function getTempEnvParam(key: string): any {
  return tempEnvParam[key]
}

export function removeTempEnvParam(key: string): void {
  delete tempEnvParam[key]
}

// TODO-TS-MIGRATION-MEDIUM: app.services 타입 정의 필요
export function getAppServices(): any {
  const appServices = getTempEnvParam('app.services')
  return appServices
}

export function useAiSummary(forSettings = false): boolean {
  const appServices = getTempEnvParam('app.services')
  if (appServices != null && appServices.ai != null && appServices.ai.summary === false) {
    return false
  }
  const state = getStore().getState() as any // TODO-TS-MIGRATION-MEDIUM: Phase 4에서 RootState 타입 적용
  const { settings } = state
  if (forSettings === false && settings.ai != null && settings.ai.summary === false) {
    return false
  }
  return !__ENV_PRODUCTION__
}

export default {
  getRouterType,
  getDefaultPage,
  setEnvParam,
  getEnvParam,
  removeEnvParam,
  getAppServices,
}
